import { CoreString } from "../../../core/String";
export const ROOT_NAME = "/";
const REGEX_PATH_SANITIZE = /\/+/g;
export class ObjectsController {
  constructor(scene) {
    this.scene = scene;
  }
  findObjectByMask(mask) {
    return this.findObjectByMaskInObject(mask, this.scene.threejsScene());
  }
  findObjectByMaskInObject(mask, object, objectPath = "") {
    for (let child of object.children) {
      const childName = this._sanitizePath(child.name);
      const path = this._sanitizePath(`${objectPath}/${childName}`);
      if (CoreString.matchMask(path, mask)) {
        return child;
      }
      const grandChild = this.findObjectByMaskInObject(mask, child, path);
      if (grandChild) {
        return grandChild;
      }
    }
  }
  objectsByMask(mask) {
    const list = [];
    this.traverseObjectsWithMask(mask, (obj) => {
      list.push(obj);
    });
    return list;
  }
  objectsByMaskInObject(mask, object, list = [], objectPath = "") {
    this.traverseObjectsWithMask(mask, (obj) => {
      list.push(obj);
    });
    return list;
  }
  traverseObjectsWithMask(mask, callback, invertMask = false) {
    this.traverseObjectsWithMaskInObject(mask, this.scene.threejsScene(), callback, invertMask);
  }
  traverseObjectsWithMaskInObject(mask, object, callback, invertMask, objectPath = "") {
    for (let child of object.children) {
      const childName = this._sanitizePath(child.name);
      const path = this._sanitizePath(`${objectPath}/${childName}`);
      let match = CoreString.matchMask(path, mask);
      if (invertMask) {
        match = !match;
      }
      if (match) {
        callback(child);
      }
      this.traverseObjectsWithMaskInObject(mask, child, callback, invertMask, path);
    }
  }
  objectPath(object) {
    const parent = object.parent;
    if (parent) {
      const parentPath = this.objectPath(parent);
      return this._sanitizePath(`${parentPath}/${object.name}`);
    } else {
      return object.name;
    }
  }
  _sanitizePath(path) {
    return path.replace(REGEX_PATH_SANITIZE, "/");
  }
}
